import { format, parse } from 'date-fns';
import { List } from 'immutable';
import { createSelector } from 'reselect';

import { selectedStructure } from '@sophocles/features/sites/slices/selectedStructure/selectors';

export const monthlySolarReportSelector = state => state.entities.monthlySolarReports;

export const getMonthlySolarReportSelector = createSelector(monthlySolarReportSelector, reports =>
  reports.map(report => {
    const todayFormatted = format(new Date(), 'yyyy-MM-dd');
    return report.toMap().set('moment', parse(report.get('month_end_date', todayFormatted), 'yyyy-MM-dd', new Date()));
  }),
);

export const getMonthlySolarReportsForSelectedStructure = createSelector(
  selectedStructure,
  getMonthlySolarReportSelector,
  (structure, reports) => {
    if (structure < -1) {
      return List();
    }
    return reports.filter(report => report.get('site', -1) == structure).toList();
  },
);
